/* social-share-animation JavaScript/jQuery */
jQuery(function( $ ) {

    $( '.social-share a:not(".btn")' ).on( 'mouseenter', function() {
        $( this ).animateCss( 'jello' );
    });

});
